module.exports = __webpack_public_path__ + "static/media/banner-1.4a860686.jpg";